import React from "react";
import { connect } from "react-redux";
import logo from "../Asset/download.jpg";
import API from "../helpers/api";
import axios from "axios";
import { getVisitorSearchList } from "../Actions/VisitorManagement"
import Role from "../helpers/role";
import Autocomplete from "react-autocomplete";
import swal from "sweetalert";
import { getCrewIdList } from "../Actions/VisitorManagement"
import { toast } from "react-toastify";

let searchData = {
  shipId: 0,
  PageNumber: 1,
  isPass: false,
  showAllResult: true,
  PageSize: 25,
  shipName: "",
  fromDate: "",
  toDate: "",
}

let userRole = localStorage.getItem("UserRoles");

class VisitorEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("currentUser")),
      visitorData: {
        visitorId: 0,
        crewMemberId: 0,
        photo: "",
        photoName: "",
        isDeleted: false,
      },
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.UpdateData = this.UpdateData.bind(this);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch({ type: "SubBannerTitle", data: "Visitor Management" });
    dispatch(getCrewIdList())
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { dispatch, visitorDetails } = nextProps;
    if (visitorDetails && visitorDetails !== "") {
      console.log(visitorDetails);
      prevState.visitorData.visitorId = visitorDetails.visitorId;
      prevState.visitorData.photo = visitorDetails.photo;
      if (visitorDetails.photoName !== null) {
        prevState.visitorData.photoName = visitorDetails.photoName;
      }
    }
  }
  ClearInput = () => {
    this.state.visitorData.crewMemberId = "";
    this.setState({});
  };

  handleInputChange(e) {
    this.state.visitorData[e.target.name] = parseInt(e.target.value);
    this.setState({});
  }
  UpdateData() {
    const { dispatch, history, visitorDetails } = this.props;
    if (this.state.visitorData.visitorId !== 0 && this.state.visitorData.crewMemberId !== 0) {
      let url = `${API.UpdateVisitor}?crewMemberId=${this.state.visitorData.crewMemberId}&VisitorId=${this.state.visitorData.visitorId}&IsDeleted=${this.state.visitorData.isDeleted}`;
      axios
        .put(url)
        .then((response) => {
          if (response?.status === 200) {
            toast.success("Visitor Updated Successfully", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            dispatch(getVisitorSearchList(searchData, 1));
            this.props.history.push(`/Home/Management/VisitorManagement`);
          }
        })
        .catch((error) => {
          swal("Error!", "Something went wrong. Please try again.", "warning");
          console.log("Error in Update Crew" + error);
        });
    }
    else {
      swal('Error!', 'Please fill the crewId', 'warning')
    }
  }

  hideSidePanel = () => {
    this.props.history.push(`/Home/Management/VisitorManagement`);
  };
  NewVisitorData = () => {
    this.props.history.push(`/Home/Management/AddNewVisitor`);
  };

  BacktoPrevious() {
    this.props.history.goBack();
  }

  render() {
    const { showSidePane, CrewIdList } = this.props;
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row px-3 pb-3">
            <button
              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
              onClick={() => this.BacktoPrevious()}
            >
              <div style={{ position: 'relative' }}>
                <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Back</span>
              </div>
            </button>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="panel-box">

                <div
                  className="card MM-card-header mb-0"
                  style={{ backgroundColor: "white", border: "0px" }}
                >
                  <div className="card-body">
                    <h5
                      className="card-title ml-4 mt-2"
                      style={{ color: "092a51" }}
                    >
                      Update Visitor{" "}
                    </h5>
                  </div>
                </div>
                <div className="search-filter-box">
                  <div className="row pb-1">
                    <div className="col-sm-2 m-auto text-right">
                      <div className="text-center rounded-circle">
                        <img
                          src={
                            this.state.visitorData.photo &&
                              this.state.visitorData.photo !== ""
                              ? this.state.visitorData.photo
                              : logo
                          }
                          alt="Smiley face"
                          style={{ width: "145px", height: "140px" }}
                          class="rounded-circle"
                        ></img>
                      </div>
                    </div>
                    <div className="col-sm-10">
                      <div className="row">
                        <div className={showSidePane ? "col-lg-4 " : "col-lg-4 "}>
                          <label className="form-label">Crew Id</label>
                          <br></br>
                          <select
                            className="form-control"
                            name="crewMemberId"
                            value={this.state.visitorData.crewMemberId}
                            onChange={(e) => this.handleInputChange(e)}
                          >
                            <option value="">Select Crew Id</option>
                            {CrewIdList &&
                              CrewIdList.map((crew) => (
                                <option value={crew.crewMemberId}>
                                  {crew.crewId}
                                </option>
                              ))}
                          </select>

                        </div>

                        <div className="col-lg-12 pt-3">
                          <label></label>
                          <br></br>
                          <div
                            className="search-btn-col"
                            style={{ textAlign: "end" }}
                          >
                            <button
                              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                              type="submit"
                              onClick={() => this.NewVisitorData()}
                            >
                              {" "}
                              ASSIGN NEW CREW
                            </button>

                            <button
                              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue ml-3"
                              type="submit"
                              onClick={() => this.UpdateData()}
                            >
                              {" "}
                              UPDATE
                            </button>
                            <button
                              className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                              type="button"
                              onClick={() => this.hideSidePanel()}
                            >
                              {" "}
                              Cancel{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    visitorDetails: state.VisitorManagementReducer.VisitorUserDetails,
    CrewIdList: state.VisitorManagementReducer.CrewIdList || []
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(VisitorEdit);